<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form @submit.prevent="save()">
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Location"
                          :state="stateForField('locationId')"
                          :invalid-feedback="errorForField('locationId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="locationName"
                          :variant="hasError('locationId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="location in locations" :key="location.locationId"
                                 @click.prevent="setLocation(location)">{{ location.name + ' (' + location.type + ')' }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group :label-cols="4"
                          label="Provider"
                          :state="stateForField('providerId')"
                          :invalid-feedback="errorForField('providerId')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="providerName"
                          :variant="hasError('providerId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="provider in providers" :key="provider.providerId"
                                 @click.prevent="setProvider(provider)">{{ provider.displayName }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group v-if="!bundlesEnabled" horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('isSelfPay')"
                          :invalid-feedback="errorForField('isSelfPay')"
                          label="Self Pay?"
                          label-class="text-right">
              <b-form-radio-group v-model="estimate.isSelfPay" class="pt-2" :options="selfPayOptions"/>
            </b-form-group>
            <b-form-group v-if="bundlesEnabled" horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('estimateType')"
                          :invalid-feedback="errorForField('estimateType')"
                          label="Estimate Type"
                          label-class="text-right">
              <b-form-radio-group stacked v-model="estimate.estimateType" class="pt-2" :options="estimateTypeOptions"/>
            </b-form-group>
            <b-form-group v-if="hasFeeSchedules && allowableFeeSchedules && allowableFeeSchedules.length > 1" :label-cols="4"
                          label="Fee Schedule"
                          :state="stateForField('organizationAllowableFeeScheduleId')"
                          :invalid-feedback="errorForField('organizationAllowableFeeScheduleId')"
                          label-class="text-right">
              <b-dropdown  menu-class="dropdown-container" :text="allowableFeeScheduleName"
                          :variant="hasError('organizationAllowableFeeScheduleId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="feeSchedule in allowableFeeSchedules" :key="feeSchedule.organizationAllowableFeeScheduleId"
                                 @click.prevent="setAllowableFeeSchedule(feeSchedule)">{{ feeSchedule.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group v-if="hasAscLocation && hasFeeSchedules && matchingAscFeeSchedules && matchingAscFeeSchedules.length > 1" :label-cols="4"
                          label="ASC Fee Schedule"
                          :state="stateForField('organizationAscFeeScheduleId')"
                          :invalid-feedback="errorForField('organizationAscFeeScheduleId')"
                          label-class="text-right">
              <b-dropdown  menu-class="dropdown-container" :text="ascFeeScheduleName"
                           :variant="hasError('organizationAscFeeScheduleId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="feeSchedule in matchingAscFeeSchedules" :key="feeSchedule.organizationAscFeeScheduleId"
                                 @click.prevent="setAscFeeSchedule(feeSchedule)">{{ feeSchedule.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
            <b-form-group v-if="!estimate.isSelfPay && patientInsurances.length > 1" :label-cols="4"
                          label="Insurance"
                          :state="stateForField('organizationPatientInsuranceId')"
                          :invalid-feedback="errorForField('organizationPatientInsuranceId')"
                          label-class="text-right">
              <b-dropdown  menu-class="dropdown-container" :text="insuranceName"
                           :variant="hasError('organizationPatientInsuranceId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="insurance in patientInsurances" :key="insurance.organizationPatientInsuranceId"
                                 @click.prevent="setInsurance(insurance)"
                >{{ insurance.insuranceCompany }}, {{ insurance.insurancePriority }}
                </b-dropdown-item>
              </b-dropdown>
              <div v-if="employerBenefits === true" class="mt-2"><font-awesome-icon class="orange mr-1" size="sm" :icon="['far','chart-network']"/><strong>Employer Benefits Available</strong></div>
            </b-form-group>
              <div class="row pb-3 insurance-row" v-if="patientInsurances.length === 1 && estimate.isSelfPay === false">
                <div class="col-4 pr-1 text-right">Insurance Plan</div>
                <div><div class="col-12"><strong>{{ patientInsurances[0].insuranceCompany }}</strong></div>
                <div v-if="employerBenefits === true" class="col"><font-awesome-icon class="orange mr-1" size="sm" :icon="['far','chart-network']"/><strong>Employer Benefits Available</strong></div>
              </div>
              </div>
            <b-form-group :label-cols="4" label="Lead Code" label-align="right" :state="stateForField('leadCode')" :invalid-feedback="errorForField('leadCode')">
              <b-form-input v-model="estimate.leadCode"></b-form-input>
            </b-form-group>
            <b-form-group :label-cols="4" label="Lead Code Modifier" label-align="right" :state="stateForField('leadCodeModifier')" :invalid-feedback="errorForField('leadCodeModifier')">
              <b-form-input v-model="estimate.leadCodeModifier"></b-form-input>
            </b-form-group>
            <b-form-group horizontal
                          :label-cols="4"
                          breakpoint="md"
                          :state="stateForField('hasImplant')"
                          :invalid-feedback="errorForField('hasImplant')"
                          :description="implantDescription"
                          :disabled="implantDisabled"
                          label="Implant Included?"
                          label-class="text-right">
              <b-form-radio-group v-model="estimate.hasImplant" class="pt-2" :options="yesNoOptions"/>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-row">
              <div class="col-4"></div>
              <div class="col"><h6>Matching Estimate Templates</h6></div>
            </div>
            <div v-for="estimateTemplate in matchingEstimateTemplates" :key="estimateTemplate.organizationEstimateTemplateId" class="form-row bundle-box">
              <div class="col-1 mx-2 my-2">
                <div class="bundle-selection">
                  <font-awesome-icon @click="selectEstimateTemplate(estimateTemplate)" v-if="estimate.organizationEstimateTemplateId !== estimateTemplate.organizationEstimateTemplateId" class="align-middle"  :icon="['far', 'circle']"/>
                  <font-awesome-icon @click="unselectEstimateTemplate(estimateTemplate)" v-if="estimate.organizationEstimateTemplateId === estimateTemplate.organizationEstimateTemplateId" class="align-middle" :icon="[ 'far', 'check-circle']"/>
                </div>
              </div>
              <div class="col my-2">
                <div><h2 class="mb-0">{{ estimateTemplate.name }}</h2></div>
                <div class="codes">
                <span class="field-label">Procedure Codes: </span>&nbsp;
                <div v-for="(line, index) in estimateTemplate.lines" v-if="estimateTemplate.lines" :key="'line-' + index"> {{ displayCode(line) }}<span v-if="index < estimateTemplate.lines.length - 1">,&nbsp;</span></div>
                </div>
                  <div class="codes">
                  <span class="field-label">Diagnostic Codes: </span>&nbsp;
                  <span v-if="estimateTemplate.primaryIcdCmCode || estimateTemplate.secondaryIcdCmCode">{{ estimateTemplate.primaryIcdCmCode ? formatICD10(estimateTemplate.primaryIcdCmCode.code) : ''}}<template v-if="estimateTemplate.primaryIcdCmCode && estimateTemplate.secondaryIcdCmCode">,</template> {{ estimateTemplate.secondaryIcdCmCode ? formatICD10(estimateTemplate.secondaryIcdCmCode.code) : ''}}
                 </span>
                </div>
              </div>
            </div>
            <div  v-if="!matchingEstimateTemplates || matchingEstimateTemplates.length === 0">
              No estimate templates
            </div>
          </div>
        </div>
        <div v-if="bundlesEnabled && this.estimate.estimateType !== 'fee-for-service'" class="row">
          <div class="col-2"></div>
          <div class="col-8">
            <div class="form-row">
              <div class="col-4"></div>
              <div class="col"><h6>Matching Episodic Fees</h6></div>
            </div>
            <div v-for="bundle in matchingBundles" :key="bundle.organizationBundleId" class="form-row bundle-box">
              <div class="col-2">
                <div class="bundle-selection">
                  <font-awesome-icon @click="selectBundle(bundle)" class="align-middle" v-if="estimate.organizationBundleId !== bundle.organizationBundleId" :icon="['far', 'circle']"/>
                  <font-awesome-icon @click="unselectBundle(bundle)" class="align-middle" v-if="estimate.organizationBundleId === bundle.organizationBundleId" :icon="[ 'far', 'check-circle']"/>
                </div>
              </div>
              <div class="col">
                <div>
                  <div>{{ bundle.name }}</div>
                  <div>{{ bundle.description }}</div>
                </div>
              </div>
            </div>
            <div v-if="!matchingBundles || matchingBundles.length == 0">
              No Episodic Fees
            </div>
          </div>
        </div>

      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save Estimate
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'NewEstimateModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      patientId: {
        type: Number,
        required: true
      },

      employerBenefits: {
        type: Boolean,
        required: false
      },

      patientIsSelfPay: {
        type: Boolean,
        default: false
      },

      allowableFeeSchedules: {
        type: Array,
        required: false
      },

      ascFeeSchedules: {
        type: Array,
        required: false
      },

      bundles: {
        type: Array,
        required: false
      },

      title: {
        type: String,
        default: 'Create Estimate'
      },

      orgPatientInsurances: {
        type: Array,
        required: false
      }
    },

    data () {
      return {
        estimate: {
          locationId: null,
          providerId: null,
          organizationPatientId: null,
          isSelfPay: false,
          leadCode: '',
          estimateType: 'fee-for-service',
          organizationBundleId: 0,
          hasImplant: false,
          leadCodeModifier: '',
          organizationPatientInsuranceId: '',
          organizationEstimateTemplateId: null
        },
        estimateTemplates: [],
        isSaving: false,
        locationName: 'Click to select',
        providerName: 'Click to select',
        allowableFeeScheduleName: 'Click to select',
        ascFeeScheduleName: 'Click to select',
        selfPayOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        estimateTypeOptions: [
          { value: 'fee-for-service', text: 'Fee For Service' },
          { value: 'self-pay', text: 'Self Pay' }
        ],
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        insuranceName: 'Click to select',
        patientInsurances: []
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
          if (this.$props.patientIsSelfPay === true) {
            this.estimate.isSelfPay = true
            this.estimate.estimateType = 'self-pay'
          } else {
            this.estimate.isSelfPay = false
            this.estimate.estimateType = 'fee-for-service'
          }
        }
      },

      'estimate.leadCode' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
        }
      },

      'estimate.leadCodeModifier' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
        }
      },

      'estimate.isSelfPay' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
        }
      },

      'estimate.estimateType' (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.estimate.organizationBundleId = 0
          if (newValue === 'self-pay') {
            this.estimate.isSelfPay = true
          } else {
            this.estimate.isSelfPay = false
          }
        }
      },

      orgPatientInsurances (newValue) {
        if (newValue) {
          this.patientInsurances = newValue
        }
      }
    },

    computed: {
      providers () {
        return this.$store.organization.providers
      },

      locations () {
        return this.$store.organization.locations
      },

      bundlesEnabled () {
        return this.bundles && this.bundles.length > 0
      },

      matchingEstimateTemplates () {
        if (!this.estimateTemplates) {
          return []
        } else {
          return this.estimateTemplates.filter((aTemplate) => {
            return aTemplate.lines.some((line) => line.code === this.estimate.leadCode)
          })
        }
      },

      matchingBundles () {
        if (!this.bundles) {
          return []
        }

        if (this.estimate.estimateType === 'self-pay') {
          return this.bundles.filter((aBundle) => {
            return aBundle.code === this.estimate.leadCode && aBundle.bundleType === 'SelfPay'
          })
        }

        return []
      },

      hasAscLocation () {
        if (this.estimate.locationId) {
          const location = this.locations.filter((aLocation) => {
            if (aLocation.locationId === this.estimate.locationId) {
              return true
            }

            return false
          }).pop()

          if (location && location.ascOrganizationId > 0) {
            return true
          }
        }

        return false
      },

      hasFeeSchedules () {
        if (this.bundlesEnabled && this.estimate.estimateType === 'fee-for-service') {
          return true
        }

        if (!this.bundlesEnabled && !this.estimate.isSelfPay) {
          return true
        }

        return false
      },

      matchingAscFeeSchedules () {
        if (!this.ascFeeSchedules || this.ascFeeSchedules.length === 0) {
          return []
        }

        return this.ascFeeSchedules.filter((aFeeSchedule) => {
          return aFeeSchedule.isSelfPay === this.estimate.isSelfPay
        })
      },

      selectedBundle () {
        if (!this.bundles) {
          return null
        }

        const bundle = this.matchingBundles.filter((aBundle) => {
          return this.estimate.organizationBundleId === aBundle.organizationBundleId
        }).shift()

        if (bundle) {
          return bundle
        }

        return null
      },

      implantDescription () {
        const selectedBundle = this.selectedBundle
        if (selectedBundle) {
          if (selectedBundle.hasImplant && selectedBundle.implantRequired) {
            return 'This episode is required to have an implant.'
          }
        }

        return ''
      },

      implantDisabled () {
        const selectedBundle = this.selectedBundle
        if (selectedBundle) {
          if (selectedBundle.hasImplant && selectedBundle.implantRequired) {
            return true
          }
        }

        return false
      }
    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.estimate = {
          locationId: null,
          providerId: null,
          organizationPatientId: this.patientId,
          isSelfPay: false,
          leadCode: '',
          organizationBundleId: 0,
          organizationEstimateTemplateId: 0,
          estimateType: 'fee-for-service',
          leadCodeModifier: ''
        }
        this.providerName = 'Click to select'
        this.locationName = 'Click to select'
      },

      validate () {
        this.clearAllErrors()

        if (!this.estimate.providerId > 0) {
          this.addErrorForField('providerId', 'You must select a provider')
        }

        if (!this.estimate.locationId > 0) {
          this.addErrorForField('locationId', 'You must select a location')
        }

        return !this.hasErrors()
      },

      loadEstimateTemplates () {
        this.isLoading = true
        const parameters = {
          estimateTemplates: []
        }
        api.post('/Dashboard/EstimateTemplates', parameters).then(response => {
          this.isLoading = false
          this.estimateTemplates = response.data.templates
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load appointments: ' + error.message, error)
            this.errors = ['Error loading appointments: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
        })
      },
      setLocation (location) {
        this.estimate.locationId = location.locationId
        this.locationName = location.name
      },

      setProvider (provider) {
        this.estimate.providerId = provider.providerId
        this.providerName = provider.displayName
      },

      setAllowableFeeSchedule (feeSchedule) {
        this.estimate.organizationAllowableFeeScheduleId = feeSchedule.organizationAllowableFeeScheduleId
        this.allowableFeeScheduleName = feeSchedule.name
      },

      setAscFeeSchedule (feeSchedule) {
        this.estimate.organizationAscFeeScheduleId = feeSchedule.organizationAscFeeScheduleId
        this.ascFeeScheduleName = feeSchedule.name
      },

      selectBundle (bundle) {
        this.estimate.organizationBundleId = bundle.organizationBundleId
        if (bundle.hasImplant) {
          this.estimate.hasImplant = true
        }
      },

      unselectBundle (bundle) {
        this.estimate.organizationBundleId = 0
      },

      selectEstimateTemplate (estimateTemplate) {
        this.estimate.organizationEstimateTemplateId = estimateTemplate.organizationEstimateTemplateId
        if (estimateTemplate.bundleHasImplant === true) {
          this.estimate.hasImplant = true
        }
      },
      unselectEstimateTemplate () {
        this.estimate.organizationEstimateTemplateId = 0
      },
      setInsurance (insurance) {
        this.estimate.organizationPatientInsuranceId = insurance.organizationPatientInsuranceId
        this.insuranceName = insurance.insuranceCompany
      },

      displayCode (line) {
        if (line.modifier) {
          return line.code + '-' + line.modifier
        }

        return line.code
      },
      formatICD10 (code) {
        if (code.length > 6) {
          return code.substr(0, 3) + '.' + code.substr(3, 3) + '.' + code.substr(6)
        } else if (code.length > 3) {
          return code.substr(0, 3) + '.' + code.substr(3)
        }
        return code
      },
      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.isSaving = true
        this.errorMessage = ''

        if (this.estimate.estimateType === 'fee-for-service' && this.patientInsurances.length === 1) {
          this.estimate.organizationPatientInsuranceId = this.patientInsurances[0].organizationPatientInsuranceId
        }

        api.post('/Dashboard/Estimate', this.estimate, { timeout: 120000 }).then(response => {
          this.$emit('estimateCreated', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add estimate: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    },
    created () {
      this.loadEstimateTemplates()
    }
  }
</script>

<style scoped>
.visit-charge-body {
  font-size: 16px;
}

.current-charge .fa-trash-alt {
  cursor: pointer;
}

.current-charge .fa-trash-alt:HOVER {
  color: rgb(255, 70, 0);
}

.bundle-box {
  border-radius: 8px;
  border: #ced4da solid 1px;
  padding: 0.5em;
}

.bundle-selection {
  height: 100%;
  display: flex;
  align-items: center;
}

.bundle-selection .svg-inline--fa {
  height: 2em;
  color: rgb(255, 70, 0);
  cursor: pointer;
}

.bundle-selection svg {
  display: block;
}
.insurance-row {
  display: flex;
  flex-wrap: nowrap;
}
h2 {
  font-size: 18px;
}
.codes {
  display:flex;
}
</style>
